import { assetUrl } from '@/lib/asset-url'
import { cn } from '@/lib/utils'

// Resolved to the CDN host in prod (same-origin in dev / e2e), like every public asset. See lib/asset-url.
const BASE = assetUrl('icons/competences')

type IconType = 'loading' | 'highs' | 'lows' | 'adjust' | 'competences' | 'vectors' | 'dimensions' | 'positioning'

function srcFor(type: IconType, index: number): string | null {
  switch (type) {
    case 'loading':
      return null
    case 'highs':
    case 'lows':
    case 'adjust':
      return `${BASE}/${type}.svg`
    case 'competences':
    case 'vectors':
    case 'dimensions':
      return `${BASE}/${type}-${index}.svg`
    case 'positioning':
      return index === 0 || index === 5 || index === 10 ? `${BASE}/positioning-${index}.svg` : null
  }
}

export function IndicatorCompetencesIcon(props: {
  className?: string
  type: IconType
  index?: number
  colors?: {
    normal: string
    darker: string
  }
  size?: number
  negative?: boolean
}) {
  const size = props.size ?? 60
  const src = srcFor(props.type, props.index ?? 0)

  if (!src) return null

  return (
    <div
      style={{
        '--bg-size': `${size / 10 / 2}px`,
        '--bg-normal': props.colors?.normal ?? 'var(--bg-color-2)',
        '--bg-darker': props.colors?.darker ?? 'var(--bg-color-2)',
        'width': size,
        'height': size,
      }}
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[var(--bg-normal)]',
        props.negative && 'negative',
        props.className,
      )}
    >
      <img src={src} alt="" className="da-icon" />
    </div>
  )
}
